import { BillingCycle, SubscriptionTier } from 'ze-sdk';

export const SubscriptionNameMap: Record<SubscriptionTier, string> = {
  PERSONAL: 'Personal',
  PRO: 'Business',
  ENTERPRISE: 'Enterprise',
} as const;

export const SubscriptionDescriptionMap: Record<SubscriptionTier, string> = {
  PERSONAL: 'For individuals and small teams',
  PRO: 'For growing teams and businesses',
  ENTERPRISE: 'For large organizations',
} as const;

export const SubscriptionCycleMap: Record<BillingCycle, string> = {
  MONTHLY: 'Monthly',
  YEARLY: 'Annual',
} as const;
